import setupLogRocketReact from 'logrocket-react';

import { env } from '../../common/lib/env';
import { LogRocket, linkLogRocketSession } from '../../common/lib/logrocket';

if (env.environment === `production`) {
  LogRocket.init(env.logrocketAppId);

  setupLogRocketReact();
  linkLogRocketSession();
}
